import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type {
  CourierBase,
  CourierCreatePayload,
  CourierUpdatePayload,
  CourierResetPasswordPayload,
  CourierItem,
  CourierItemListParams,
} from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/courier`;

export const getList = async (params?: RequestParams): Promise<ApiResponseList<CourierBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<CourierBase>>(`${BASE}/index`, { params });
  return data;
};

export const getItemList = async (params?: CourierItemListParams): Promise<ApiResponse<CourierItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<CourierItem[]>>(`${BASE}/item-list`, { params });
  return data;
};

export const getById = async (id: number): Promise<ApiResponse<CourierBase>> => {
  const { data } = await axiosInstance.get<ApiResponse<CourierBase>>(`${BASE}/show`, { params: { id } });
  return data;
};

export const create = async (payload: CourierCreatePayload): Promise<ApiResponse<CourierBase>> => {
  const { data } = await axiosInstance.post<ApiResponse<CourierBase>>(`${BASE}/create`, payload);
  return data;
};

export const update = async (payload: CourierUpdatePayload): Promise<ApiResponse<CourierBase>> => {
  const { data } = await axiosInstance.post<ApiResponse<CourierBase>>(`${BASE}/update`, payload);
  return data;
};

export const remove = async (id: number): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/delete`, { id });
  return data;
};

export const resetPassword = async (payload: CourierResetPasswordPayload): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/reset-password`, payload);
  return data;
};
